import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        "search": "",
        "sort": {
            "attributes": [
                "created_date"
            ],
            "sorts": [
                "desc"
            ]
        },
        "filters": [
            // ["campusLocationName","=","gaya"]
        ],
        "pageNo": 1,
        "itemsPerPage": 2
    },
    locationfilter: {
        "listType":"campus_location",
        "replacements":["%%"]
    },
};

const visitUsSlice = createSlice({
    name: 'visitUs',
    initialState,
    reducers: {
        updateFilter: (state, action) => {
            state.filters = action.payload;
        },
        updateReducer: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const {
    updateFilter,
    updateReducer,
} = visitUsSlice.actions;

export default visitUsSlice.reducer;
